export const getImagePath = (path) => {
  return path
    ? `${process.env.REACT_APP_BASE_API_URL?.replace("/api/v2", "")}/${path}`
    : undefined;
};
